// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_j4j","cls2":"SuggestedUserCard-cls2_CBc SuggestedUserCard-cls1_j4j"};